import { useParams } from 'react-router-dom';
import { useEventYearFilter } from 'components/YearDropdown';
import { usePersistedQuery } from 'hooks/usePersistedQuery';
import { useSearchInput } from 'hooks/useSearchInput';
import GET_USER_CREDITS_ADMIN from './get-user-credits-admin';

export function useGetUserCreditsAdmin(accountId = null) {
  const { id: user_id, id2 } = useParams();
  const { yearFilter } = useEventYearFilter();
  const { input: search } = useSearchInput();

  // Skip if id2 exists (means we're in account context, not admin context)
  const shouldSkip = !!id2;

  const result = usePersistedQuery(
    GET_USER_CREDITS_ADMIN,
    `user-credits-admin-${user_id}-${accountId || 'all'}`,
    {
      variables: {
        input: {
          user_id: Number(user_id),
          ...(accountId ? { account_id: Number(accountId) } : null),
          ...(yearFilter ? { year: yearFilter } : null),
          ...search,
        },
      },
      fetchPolicy: 'cache-first',
      skip: shouldSkip,
    }
  );

  return { ...result, res: result.data };
}
